module.exports = __webpack_public_path__ + "img/white-label-gradient.c41a453f.png";